import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SPOTLIGHT } from "@/data/menu";

export default function FlavourSpotlight() {
  const [i, setI] = useState(() => Math.floor(Math.random() * SPOTLIGHT.length));

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % SPOTLIGHT.length), 3500);
    return () => clearInterval(t);
  }, []);

  const c = SPOTLIGHT[i];

  return (
    <motion.div
      data-testid="flavour-spotlight"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.9 }}
      className="absolute -bottom-6 -left-4 sm:left-2 bg-white text-noir border border-line rounded-2xl px-5 py-4 min-w-[240px]"
    >
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 rounded-full animate-pulseDot" style={{ backgroundColor: c.color }} />
        <span className="text-xs uppercase tracking-[0.15em] font-bold" style={{ color: c.color }}>
          Now Pouring · {c.use}
        </span>
      </div>
      <AnimatePresence mode="wait">
        <motion.div
          key={c.name}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.4 }}
        >
          <div className="font-display font-bold text-lg text-noir mt-1" data-testid="spotlight-name">{c.name}</div>
          <div className="font-mono text-sm text-coffee-muted">{c.calories} kcal · {c.protein}g protein · ₹{c.price}</div>
        </motion.div>
      </AnimatePresence>
      <div className="mt-3 flex gap-1.5">
        {SPOTLIGHT.map((_, idx) => (
          <button
            key={idx}
            data-testid={`spotlight-dot-${idx}`}
            onClick={() => setI(idx)}
            aria-label={`Flavour ${idx + 1}`}
            className="h-1.5 rounded-full transition-all duration-300"
            style={{ width: idx === i ? 20 : 8, backgroundColor: idx === i ? c.color : "#DAC9A8" }}
          />
        ))}
      </div>
    </motion.div>
  );
}
